import gsap from "gsap";

import { Component } from "../extends";

export default () =>
	class DetailHeader extends Component() {
		mounted() {
			this.content =
				this.el.querySelectorAll(".c-detail-header__content") || [];
		}

		animations() {
			gsap.set(this.content, {
				y: "20%",
				opacity: 0,
			});

			this.anim = gsap.timeline();

			this.anim.to(
				this.content,
				{
					y: 0,
					opacity: 1,
					ease: "sine.out",
					duration: 0.6,
				},
				0.2
			);

			this.anim.seek(0);
			this.anim.play();
		}
	};
